import React from "react";
import LoginForm from "../../components/loginForm";
import { t } from "../../../../dev/helpers/translator";
import { checkPartnerExternalLinks } from "../../../../dev/helpers/checkPartnerIntegrationExternalLinks";
import TicketInManualCheck from "../../components/ticketInManualCheck";
import Cashout from "../../components/cashout";
import ErrorLoggedInRFID from "../../components/errorLoggedInRFID/index";
import TodaysReport from "../../components/todaysReport";
import StackerBalance from "../../components/stackerBalance";
import StackerBalanceItem from "../../components/stackerBalance/pices/stackerBalanceItem";
import TicketIn from "../../components/ticketIn";
import FreeBetBonus from "../../components/freeBetBonus";
import TerminalError from "../../components/terminalError";
import CashIn from "../../components/cashIn";
import LockTerminal from "../../components/lockTerminal";
import Rules from "../../components/rules";
import CashoutByTicket from '../../components/cashoutbyticket';
import TermsAndConditions from "../../components/termsAndConditions";
import CashOutType from '../../components/cashouttype';
import ErrorBetslipEvents from "../../components/errorBetslipEvents";
import UserActionOK from "../../components/userActionOK";
import BetHistory from "../../components/betHistory";
import BetHistoryCashout from "../../components/betHistoryCashout";
import TicketInDms from "../../components/dmsTicketIn";
import BookingInfo from "../../components/bookingInfo";
import DmsCashout from "../../components/dmsCashout";
import DmsRegister from "../../components/dmsRegister";
import DmsRegisterFields from "../../components/dmsRegisterFields";
import DmsSetPinCode from "../../components/dmsSetPinCode";
import DmsLoginPinCode from "../../components/dmsLoginPinCode";
import DmsResetPinCode from "../../components/dmsResetPinCode";
import DmsRegUpdateConfirmation from "../../components/dmsRegUpdateConfirmation";
import DmsSuccess from "../../components/dmsSuccess";
import InactiveTerminal from "../../components/inactivepopup";
import DmsLoggedInCashout from "../../components/dmsLoggedInCashout";
import FailPopup from "../../components/failPopup";
import ErrorPopup from "../../components/errorPopup";
import LoyalCard from '../../components/loyalCard';
import StatisticsPopup from "../../../components/statisticsPopup";
import VideoStreamPopup from "../../../components/videoStreamPopup";
import Superbet from "../../components/superbet";
import ConfirmBet from "../../components/confirmBet";
import MultipleTicketsPopup from "../../components/multipleWinsPopup";
import Config from "../../../config/main";
import ConfirmTicketClosePopup from "../../components/confirmTicketClosePopup";
import LoyalCardInputPopup from '../../components/LoyalCardInputPopup'
import DepositMoney from "../../components/depositMoney";
import DepositMoneyPlaceCard from "../../components/depositMoneyPlaceCard";
import SuccessPopup from "../../components/successPopup";
import TransferToAccount from "../../components/transferToAccount";
import TransferToAccountDetails from "../../components/transferToAccountDetails";
import CashoutByBankCard from "../../components/cashoutByBankCard";
import ChangePasswordForm from "../../components/changePasswordForm";
import StaffLoginPopup from "../../components/staffLoginPopup";
import TerminalLockReminderPopup from "../../components/terminalLockReminderPopup";
import BetBuilderWrapper from "../betBuilderWrapper";

const authPopups = ["dmsRegister", "dmsSuccess", "dmsRegisterFields", "dmsSetPinCode", "dmsLoginPinCode", "dmsResetPinCode", "dmsRegUpdateConfirmation"];

export default function popupTemplate() {
    return <>
        {this.props.popup ? <div
            className={"popup-m" +
                (this.props.popup === "iframe" ? " casino" : this.props.popupParams ? " message" : "")
            }
            onClick={this.props.popup === "inactiveTerminal" ? this.props.closePopup() : null}>
            <div className={`mini-box-popup ${this.props.popup === "multipleTicketsPopup" ? "ticket-scan-popup" : ""}`}>
                <div className="align-wrapper" onClick={this.wrapperClick}>
                    <div className={"ver-center-view-b " +
                        (authPopups.includes(this.props.popup) ? "auth-popup" : "") +
                        (this.props.popup === "statisticsPopup" ? "stat " : "") +
                        (this.props.popup === "superbet" ? "superbet-popup" : "")+
                        (this.props.popup === "betBuilder" ? "bet-builder-popup" : "")+
                        ([
                            'loyalCardInputPopup',
                            'cashoutByBankCard',
                            'depositMoney',
                            'depositMoneyPlaceCard',
                            'successPopup',
                            'transferToAccount',
                            'transferToAccountDetails'
                        ].includes(this.props.popup) ? 'popup-new' : "") +
                        (this.props.popup === "videoStream" ? "stat videoStream" : "") +
                        (this.props.popup === 'rules' ? 'rules-popup-main' : "") +
                        (this.props.popup === "multipleTicketsPopup" ? `ticket ${this.props.popupParams?.ticketsList ? 'onlyList' : ''}` : "") +
                        (this.props.popup === 'betHistory' ? ' bet-history-p ' : "") +
                        (this.props.popup === 'freeBetBonus' ? ' bet-history-p ' : "") +
                        (this.props.popup === 'superbet' ? ' remove-button-x ' : '') +
                        (this.props.popup === 'confirmBet' ? ' remove-button-x ' : "") +
                        (this.props.popup === "termsAndConditions" ? " paston-rules-popup " : "") +
                        (this.props.popup === "casinoTicketIn" ? " casino-lottery-ticket " : '')}>
                        <div className="title-popup-page-m">
                            <h4>{
                                {
                                    ForgotPassword: t("Reset password"),
                                    CashOutDialog: t("CashOut"),
                                    PartialCashOutDialog: t("Partial Cash Out"),
                                    CounterOfferDialog: t("SuperBet Counter-Offer"),
                                    ConfirmDeposit: t("Confirm Deposit"),
                                    ResetPasswordForm: t("Reset password"),
                                    GamePopup: "",
                                    ConfirmWithdraw: t("Confirm withdraw"),
                                    message: t(this.props.popupParams && this.props.popupParams.title),
                                    templateAsMessage: t(this.props.popupParams && this.props.popupParams.title),
                                    confirm: t(this.props.popupParams && this.props.popupParams.title),
                                    accept_or_cancel: t(this.props.popupParams && this.props.popupParams.title),
                                    dmsSuccess: t(this.props.popupParams && this.props.popupParams.title),
                                    superbet: t('Offer review'),
                                    betBuilder: t('Bet Builder | {1}', this.props.popupParams && this.props.popupParams.title),
                                }[this.props.popup]
                            }</h4>
                            {
                                Config.enableMultipleWinsPopup && this.props.popup === "multipleTicketsPopup"
                                    ? this.props.popupParams && this.props.popupParams.disable ? null
                                        : <div>
                                            <button
                                                className="popup-closed-b"
                                                onClick={
                                                    this.props.popupParams?.onClose?.() || (this.props.tickets && Object.keys(this.props.tickets).length !== 0) && !this.props.popupParams?.onlyList
                                                        ? this.props.openPopup('confirmTicketClose')
                                                        : this.props.closePopup()
                                                }
                                            />
                                            {
                                                !this.props.popupParams?.onlyList &&
                                                <button className='popup-minimize' onClick={this.props.closePopup()} />
                                            }
                                        </div>
                                    : this.props.popupParams && this.props.popupParams.disable ? null
                                        : <button className="popup-closed-b" onClick={this.props.popupParams?.onClose?.() || this.props.closePopup()} />
                            }
                        </div>
                        <div className={`popup-content-view-m timer-visible ${this.props.popup === "todaysReport" && "scroll-inh"} ${this.props.popup === "videoStream" && "video"}`}>
                            {(() => {
                                switch (true) {
                                    case this.props.popup === "LoginForm" && !checkPartnerExternalLinks("login"):
                                        return <LoginForm {...this.props.popupParams} />;
                                    case this.props.popup === "ChangePasswordForm":
                                        return <ChangePasswordForm {...this.props.popupParams} />;
                                    case this.props.popup === "message":
                                        return <div className={"popup-message " + this.props.popupParams.type}
                                            dangerouslySetInnerHTML={{ __html: this.props.popupParams.body }} />;
                                    case this.props.popup === "templateAsBody":
                                        return <div
                                            className={"popup-message app-info  " + this.props.popupParams.type}>{this.props.popupParams.body}</div>;
                                    case this.props.popup === "iframe":
                                        return <div className="popup-iframe">
                                            <iframe key={this.props.popupParams.iframeUrl} src={this.props.popupParams.iframeUrl} className={"terminal-iframe"} />
                                        </div>;
                                    case this.props.popup === "accept_or_cancel":
                                        return <div
                                            className={"popup-message accept_or_cancel " + this.props.popupParams.type}>
                                            <p dangerouslySetInnerHTML={{ __html: this.props.popupParams.body }} />
                                            <button className="button-view-normal-m"
                                                onClick={this.props.popupParams.accept_button_function}> {t(this.props.popupParams.accept_button)}</button>
                                            <button className="button-view-normal-m trans-m"
                                                onClick={this.props.closePopup()}> {t(this.props.popupParams.cancel_button)}</button>
                                        </div>;
                                    case this.props.popup === "confirm":
                                        return <div
                                            className={"popup-confirm-message " + this.props.popupParams.type}
                                            key="confirmPopup">
                                            <p dangerouslySetInnerHTML={{ __html: this.props.popupParams.body }} />
                                            {this.props.popupParams.answers.map((answer, i) =>
                                                <div key={i} className="button-separator-view">
                                                    <button
                                                        onClick={this.answerDialog(this.props.popupParams.id, answer.value, this.props.popupParams.data)}
                                                        className={"button-view-normal-m " + answer.type}
                                                    >
                                                        {answer.title}
                                                    </button>
                                                </div>
                                            )}
                                        </div>;
                                    case this.props.popup === "ticket-in":
                                        return <TicketIn {...this.props.popupParams} />;
                                    case this.props.popup === "terminal-error":
                                        return <TerminalError {...this.props.popupParams} />;
                                    case this.props.popup === 'loyalCard':
                                        return <LoyalCard />;
                                    case this.props.popup === "confirmTicketClose":
                                        return <ConfirmTicketClosePopup {...this.props.popupParams} />;
                                    case this.props.popup === "lockTerminal":
                                        return <LockTerminal {...this.props.popupParams} />;
                                    case this.props.popup === "ticketInManualCheck":
                                        return <TicketInManualCheck />;
                                    case this.props.popup === "cashOutType":
                                        return <CashOutType {...this.props.popupParams} />;
                                    case this.props.popup === "cashout":
                                        return <Cashout />;
                                    case this.props.popup === "cashoutByBankCard":
                                        return <CashoutByBankCard />;
                                    case this.props.popup === "transferToAccount":
                                        return <TransferToAccount />
                                    case this.props.popup === "transferToAccountDetails":
                                        return <TransferToAccountDetails {...this.props.popupParams} />
                                    case this.props.popup === "depositMoneyPlaceCard":
                                        return <DepositMoneyPlaceCard />;
                                    case this.props.popup === "depositMoney":
                                        return <DepositMoney />;
                                    case this.props.popup === "successPopup":
                                        return <SuccessPopup {...this.props.popupParams} />;
                                    case this.props.popup === "cashoutByTicket":
                                        return <CashoutByTicket />;
                                    case this.props.popup === "rules":
                                        return <Rules />;
                                    case this.props.popup === "betBuilder":
                                        return <BetBuilderWrapper {...this.props.popupParams} />;
                                    case this.props.popup === "loyalCardInputPopup":
                                        return <LoyalCardInputPopup />
                                    case this.props.popup === "termsAndConditions":
                                        return <TermsAndConditions {...this.props.popupParams} />;
                                    case this.props.popup === "inactiveTerminal":
                                        return <InactiveTerminal {...this.props.popupParams} />;
                                    case this.props.popup === "terminalLockReminder":
                                        return <TerminalLockReminderPopup {...this.props.popupParams} />;
                                    case this.props.popup === "cashin":
                                        return <CashIn {...this.props.popupParams} />;
                                    case this.props.popup === "multipleTicketsPopup":
                                        return <MultipleTicketsPopup {...this.props.popupParams} />;
                                    case this.props.popup === "errorLoggedInRFID":
                                        return <ErrorLoggedInRFID {...this.props.popupParams} />;
                                    case this.props.popup === "todaysReport":
                                        return <TodaysReport />;
                                    case this.props.popup === "stackerBalance":
                                        return <StackerBalance />;
                                    case this.props.popup === "userActionOK":
                                        return <UserActionOK {...this.props.popupParams} />;
                                    case this.props.popup === "showStackerBalance":
                                        return <StackerBalanceItem {...this.props.popupParams} />;
                                    case this.props.popup === "errorBetslipEvents":
                                        return <ErrorBetslipEvents />;
                                    case this.props.popup === "freeBetBonus":
                                        return <FreeBetBonus />;
                                    case this.props.popup === "lockAndUnlock":
                                        return <LockAndUnlock {...this.props.popupParams} />;
                                    case this.props.popup === "statisticsPopup":
                                        return <StatisticsPopup {...this.props.popupParams} />;
                                    case this.props.popup === "staffLogin":
                                        return <StaffLoginPopup {...this.props.popupParams} />;
                                    case this.props.popup === "videoStream":
                                        return <VideoStreamPopup {...this.props.popupParams} />;
                                    case this.props.popup === "betHistory":
                                        return <BetHistory {...this.props.popupParams} />;
                                    case this.props.popup === "betHistoryCashout":
                                        return <BetHistoryCashout {...this.props.popupParams} />;
                                    case this.props.popup === "dmsTicketIn":
                                        return <TicketInDms {...this.props.popupParams} />;
                                    case this.props.popup === "dmsLoggedInCashout":
                                        return <DmsLoggedInCashout {...this.props.popupParams} />;
                                    case this.props.popup === "dmsRegister":
                                        return <DmsRegister {...this.props.popupParams} />;
                                    case this.props.popup === "dmsRegisterFields":
                                        return <DmsRegisterFields {...this.props.popupParams} />;
                                    case this.props.popup === "dmsSetPinCode":
                                        return <DmsSetPinCode {...this.props.popupParams} />;
                                    case this.props.popup === "dmsLoginPinCode":
                                        return <DmsLoginPinCode {...this.props.popupParams} />;
                                    case this.props.popup === "dmsResetPinCode":
                                        return <DmsResetPinCode {...this.props.popupParams} />;
                                    case this.props.popup === "dmsRegUpdateConfirmation":
                                        return <DmsRegUpdateConfirmation {...this.props.popupParams} />;
                                    case this.props.popup === "dmsSuccess":
                                        return <DmsSuccess {...this.props.popupParams} />;
                                    case this.props.popup === "dmsCashout":
                                        return <DmsCashout {...this.props.popupParams} />;
                                    case this.props.popup === "errorPopup":
                                        return <ErrorPopup {...this.props.popupParams} />;
                                    case this.props.popup === "failPopup":
                                        return <FailPopup {...this.props.popupParams} />;
                                    case this.props.popup === "bookingInfo":
                                        return <BookingInfo {...this.props.popupParams} />;
                                    case this.props.popup === "showPaymentPopup":
                                        return <span className="money" />;
                                    case this.props.popup === "superbet":
                                        return <Superbet {...this.props.popupParams} />;
                                    case this.props.popup === "confirmBet":
                                        return <ConfirmBet {...this.props.popupParams} />;
                                    default:
                                        return null;
                                }
                            })()}
                        </div>
                    </div>
                </div>
            </div>
        </div> : null}

        <InactiveTerminal />
    </>;
}
